module.exports = __webpack_public_path__ + "img/checklist_3_french.f5bd239c.png";